// Types
import { RootState } from 'types/RootState.types';

// Config
import paymentTypeConstants from '@constants/paymentTypeConstants';
import isZeroAmount from '@utils/payment/isZeroAmount';
import { getStorageItem } from '@utils/storage/storage';

export function dispatchMonetateEvent({
  eventName,
  trackData = true,
}: { eventName?: string; trackData?: boolean } = {}) {
  if (!eventName) return;

  try {
    window.monetateQ = window.monetateQ || [];
    window.monetateQ.push(['trackEvent', [eventName]]);

    if (trackData) {
      window.monetateQ.push(['trackData']);
    }

    if (getStorageItem('logAnalytics', true) === 'true') {
      /* eslint-disable no-console */
      console.warn('---------- DISPATCH MONETATE EVENT ----------');
      console.warn(`-- event: ${eventName} --`);
      /* eslint-enable no-console */
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to dispatch Monetate event:', err);
  }
}

export function shouldTriggerBarclaysMonetateEvent({
  isStripe = false,
  state,
}: {
  isStripe?: boolean;
  state: RootState;
}) {
  const selectedPaymentType = state.payment?.selectedPaymentType || '';
  const isPayPal = selectedPaymentType?.includes(paymentTypeConstants.PAYPAL) || false;
  const isPosCredit = selectedPaymentType?.includes(paymentTypeConstants.POS_CREDIT) || false;
  const isKlarna = selectedPaymentType?.includes(paymentTypeConstants.KLARNA) || false;
  const isZeroOutstandingBalance = isZeroAmount(state.orderForm?.amounts?.outstandingBalance);

  return !isKlarna && !isStripe && !isPayPal && !isPosCredit && !isZeroOutstandingBalance;
}
